import { render, staticRenderFns } from "./pwa_article_image.vue?vue&type=template&id=65a38926&scoped=true&"
import script from "./pwa_article_image.vue?vue&type=script&lang=js&"
export * from "./pwa_article_image.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a38926",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65a38926')) {
      api.createRecord('65a38926', component.options)
    } else {
      api.reload('65a38926', component.options)
    }
    module.hot.accept("./pwa_article_image.vue?vue&type=template&id=65a38926&scoped=true&", function () {
      api.rerender('65a38926', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/news/modal/item/tabs/pwa_article_image.vue"
export default component.exports